export const DELETE_DATA_MESSAGE_TYPE = 'DELETE_DATA_MESSAGE_TYPE';

export const DATA_MESSAGE_TYPE_OPTIONS = [
	'message',
	'log',
	'revision'
];

/**
 * Model for Data Message Type
 *
 */
export class DataMessageTypeModel {
	id?: string;
	nexsysAttribute?: string;
	appScopeType?: string;
	acuityType?: string;
	cmpAcuityType?: string;
}

export class LenderCompanyMessageModel {
	id?: string;
	acuityMessage?: string;
	appScopeMessage?: string;
	nexsysLenderCompanyId?: string;
}

export class AssetOnCompletionModel {
	id?: string;
	description?: string;
	files?: Array<string>;
	origin?: string;
	created?: string;
	createdBy?: string;
	updated?: string;
	updatedBy?: string;
}
